import Swiper, { Navigation, Pagination } from 'swiper/core';

Swiper.use([Navigation, Pagination]);

class ExternalWidgetSabato {
  constructor() {
    this.dom = {
      swiper: document.getElementById('propertySwiperSabato'),
    };

    this.components = {
      swiper: null,
    };

    this.data = {
      swiperConfigMobile: {
        slidesPerView: 'auto',
        spaceBetween: 18,
        loop: false,
        allowTouchMove: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      swiperConfigMobileArticleSide: {
        slidesPerView: 1,
        spaceBetween: 9,
        loop: true,
        allowTouchMove: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      swiperConfigDesktop: {
        slidesPerView: 4,
        spaceBetween: 30,
        loop: true,
        allowTouchMove: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
    };

    this.events = {
      updateCssVars: this.updateCssVars.bind(this),
    };

    this.properties = {
      mql: window.matchMedia('(min-width: 992px)'),
    };

    this.mount();
  }

  mount() {
    this.onMqlChange();
    this.updateCssVars();
    this.properties.mql.addEventListener('change', this.onMqlChange.bind(this));
    window.addEventListener('resize', this.updateCssVars.bind(this));
  }

  // eslint-disable-next-line class-methods-use-this
  updateCssVars() {
    const swiperContainer = document.querySelector('.swiper-container');
    const root = document.documentElement;

    if (!swiperContainer) return;

    const rect = swiperContainer.getBoundingClientRect();
    root.style.setProperty('--sabatoSwiperButtonsTop', `${rect.top}px`);
    root.style.setProperty('--sabatoSwiperButtonsLeft', `${rect.left}px`);
    root.style.setProperty('--sabatoSwiperButtonsWidth', `${rect.width}px`);
    root.style.setProperty('--sabatoSwiperButtonsHeight', `${rect.height}px`);
  }

  onMqlChange() {
    if (this.components.swiper) {
      this.components.swiper.destroy();
      this.components.swiper = undefined;
    }

    if (this.properties.mql.matches) {
      this.initSwiper(this.data.swiperConfigDesktop);
      return;
    }

    if (document.documentElement.classList.contains('is-article-side')) {
      this.initSwiper(this.data.swiperConfigMobileArticleSide);
      return;
    }

    this.initSwiper(this.data.swiperConfigMobile);
  }

  initSwiper(swiperOptions) {
    const defaultOptions = {
      speed: 350,
      pagination: {
        el: '.swiper-pagination',
        dynamicBullets: false,
        clickable: true,
      },
      breakpointsInverse: true,
      breakpoints: {
        576: {
          spaceBetween: 30,
        },
      },
      on: {
      },
    };
    const options = Object.assign(defaultOptions, swiperOptions);
    this.components.swiper = new Swiper('.swiper-container', options);
  }
}

if (document.getElementById('external-property-widget-sabato')) {
  // eslint-disable-next-line no-new
  new ExternalWidgetSabato();
}
